// extracted by mini-css-extract-plugin
module.exports = {"IconBase":"IconJasracLogo_IconBase__MqUf4","IconPrimary":"IconJasracLogo_IconPrimary__3xWeB"};